<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-50 md-size-50">
			<h4>{{translate(locale.user)}}</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<md-card>
				<md-card-content>
					<loading v-if="!loaded" />
					<div v-if="loaded">
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-50">
								<md-field>
									<label>{{translate(locale.searchUser)}}</label>
									<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-50 md-size-25">
								<md-field>
									<label>{{translate(locale.status)}}</label>
									<md-select :placeholder="translate(locale.statusAll)" v-model="search.status">
										<md-option value="">{{translate(locale.all)}}</md-option>
										<md-option value="1">{{translate(locale.active)}}</md-option>
										<md-option value="0">{{translate(locale.disabled)}}</md-option>
									</md-select>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-50 md-size-25">
								<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">{{translate(locale.search)}}</md-button>
							</div>
						</div>
						<md-table v-if="userList.length > 0">
							<md-table-row>
								<md-table-head></md-table-head>
								<md-table-head>{{translate(locale.userName)}}</md-table-head>
								<md-table-head>ព័ត៌មាន</md-table-head>
								<md-table-head>សមាជិកភាព</md-table-head>
								<md-table-head>{{translate(locale.userLogin)}}</md-table-head>
								<md-table-head style="min-width: 180px;">{{translate(locale.createdDate)}}</md-table-head>
								<md-table-head>កម្មវិធីណែនាំ</md-table-head>
								<md-table-head>{{translate(locale.status)}}</md-table-head>
								<md-table-head>{{translate(locale.action)}}</md-table-head>
							</md-table-row>

							<md-table-row v-for="(user, index) in userList">
								<md-table-cell>​{{ index + 1 }}</md-table-cell>
								<md-table-cell><b>{{user.name}}</b><br>{{user.username}}</md-table-cell>
								<md-table-cell>{{user.phone_number || "មិនមានលេខទូរស័ព្ទ"}}<br>{{user.email || "មិនមានអ៊ីម៉ែល"}}</md-table-cell>
								<md-table-cell><b>
									<span class="green" v-if="(new Date()).getTime() / 1000 < user.expiry_date">មានសុពលភាព ({{config.getExpire(user.expiry_date).total}} ថ្ងៃ)</span>
									<span class="red" v-else>មិនមានសុពលភាព</span>
								</b></md-table-cell>
								<md-table-cell>
									<b>{{translate(config.datelify(user.last_login))}}</b><br>
									({{translate(config.getAge(user.last_login))}})<br>
								</md-table-cell>
								<md-table-cell>
									<b>{{translate(config.datelify(user.created_date))}}</b><br>
									({{translate(config.getAge(user.created_date))}})
								</md-table-cell>
								<md-table-cell>
									<span class="late" v-if="user.referral_status == 0">{{translate(locale.disabled)}}</span>
									<span class="green" v-if="user.referral_status == 1">{{translate(locale.active)}}</span>
								</md-table-cell>
								<md-table-cell>
									<span class="late" v-if="user.status == 0">{{translate(locale.disabled)}}</span>
									<span class="green" v-if="user.status == 1">{{translate(locale.active)}}</span>
								</md-table-cell>
								<md-table-cell>
									<!-- <router-link :to="'users/detail/' + user.hash">
										<md-button class="md-just-icon md-simple md-primary">
											<md-icon>visibility</md-icon>
											<md-tooltip md-direction="top">{{translate(locale.view)}}</md-tooltip>
										</md-button>
									</router-link>
									<md-button class="md-just-icon md-simple md-danger" @click="onDisable(user.hash)" v-if="user.status == 1">
										<md-icon>do_not_disturb_on</md-icon>
										<md-tooltip md-direction="top">{{translate(locale.disable)}}</md-tooltip>
									</md-button> -->
									<md-button class="md-just-icon md-simple md-success">
										<md-icon>verified</md-icon>
										<md-tooltip md-direction="top">មើលបន្ថែម</md-tooltip>
									</md-button>
								</md-table-cell>
							</md-table-row>
						</md-table>
						<h5 class="text-center" v-if="userList.length == 0 && loaded == true">មិនមានអ្នកប្រើប្រាស់ ។</h5>
						<div class="text-right" v-if="loadMore">
							<md-button class="md-primary" @click="searchHandler(true)">{{translate(locale.showMore)}}</md-button>
						</div>
					</div>
						<md-dialog-confirm :md-active.sync="disableDialogActive" :md-title="translate(locale.disableUser)" :md-confirm-text="translate(locale.disable)"
						:md-cancel-text="translate(locale.cancel)" @md-cancel="onCancel" @md-confirm="onDisable" />
				</md-card-content>
			</md-card>
		</div>
	</div>
</template>

<script>
	export default {
		created() {
			this.searchHandler();
		},
		data() {
			return {
				loaded: false,
				disableDialogActive: false, disableSelected: '',
				search: { text: "", status: ""},
				loadMore: false,
				userList: []
			}
		},
		methods: {
			searchHandler(more = false) {
				let size = 50;
				this.$http.post(this.config.api + "/user/user/search", {
					text: this.search.text,
					status: this.search.status,
					size: size,
					offset: more ? this.userList.length : 0
				}).then(data => {
					this.loaded = true;
					if (data.body.data.length == size) this.loadMore = true;
					else this.loadMore = false;
					this.userList = more ? this.userList.concat(data.body.data) : data.body.data;
				})
			},

			onDisable(hash) {

				if(this.disableSelected == "") {
					this.disableDialogActive = true;
					this.disableSelected = hash;
					return;
				}
				this.$http.post(this.config.api + "/admin/user/disable", {
					hash: this.disableSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have disabled the user successfully.||អ្នកបានផ្អាកដំណើរការអ្នកប្រើប្រាស់នេះដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},

			onEnable(hash) {

				this.$http.post(this.config.api + "/admin/user/enable", {
					hash: hash
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have enabled the user successfully.||អ្នកបានដាក់ដំណើរការអ្នកប្រើប្រាស់នេះដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onCancel() {
				this.disableSelected = ""
				this.disableDialogActive = false
			}	
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Users/View.vue